import React from "react";
import { Link } from "react-router-dom";
import thankYouImage from "../assets/genius-auto-trans-thankyou-page-img.webp";

const ThankYou = () => {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gray-50 px-6 py-12">
      {/* Bigger Image */}
      <img src={thankYouImage} alt="Truck delivery" className="w-72 mb-8" />

      {/* Text content */}
      <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6 text-center">
        Thank You for Your Request!
      </h1>

     <p className="text-gray-700 text-center max-w-xl mb-6 text-base md:text-sm">
  Thank you for providing the details of your vehicle for transport. Our team will handle it. <br />
  With the utmost care, we’ll review the provided details and will soon get in touch. <br />
  Your trust in <span className="text-blue-600 font-semibold">Genius Auto Transport</span> is appreciated, and we assure you a seamless experience.
</p>


      {/* Button */}
      <Link to="/home">
        <button className="px-6 py-3 bg-blue-600 text-white rounded-full font-semibold hover:bg-blue-700 transition">
          BACK TO HOME
        </button>
      </Link>
    </div>
  );
};

export default ThankYou;
